// ========== TIMESHEET STATUS ==========

export const TIMESHEET_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  APPROVED: 'approved',
  INVOICED: 'invoiced',
};

export const TIMESHEET_STATUS_LABELS = {
  draft: 'Bozza',
  sent: 'Inviato',
  approved: 'Approvato',
  invoiced: 'Fatturato',
};

export const TIMESHEET_STATUS_COLORS = {
  draft: {
    light: 'bg-neutral-100 text-neutral-700',
    dark: 'bg-neutral-800 text-neutral-300',
  },
  sent: {
    light: 'bg-blue-100 text-blue-700',
    dark: 'bg-blue-900/30 text-blue-300',
  },
  approved: {
    light: 'bg-emerald-100 text-emerald-700',
    dark: 'bg-emerald-900/30 text-emerald-300',
  },
  invoiced: {
    light: 'bg-purple-100 text-purple-700',
    dark: 'bg-purple-900/30 text-purple-300',
  },
};

export const COMPENSATION_TYPES = [
  { id: 'fixed', label: 'Compenso fisso' },
  { id: 'hourly', label: 'Tariffa oraria' },
  { id: 'daily', label: 'Tariffa giornaliera' },
  { id: 'project', label: 'A progetto' },
];
